<h2 mat-dialog-title>
  {{ title }}
</h2>

<div mat-dialog-content>
  <p>{{ message }}</p>
  @if (data.checkbox) {
  <div>
    <mat-checkbox [(ngModel)]="checkboxSelected">{{ checkboxText }}</mat-checkbox>
  </div>
  }
  <div fxLayout="row" fxLayoutGap="8px">
    <button mat-button (click)="onDismiss()">{{ textDismiss }}</button>
    <button mat-raised-button [color]="confirmColor" (click)="onConfirm()">
      {{ textConfirm }}
    </button>
  </div>
</div>
